module.exports = __webpack_public_path__ + "e2fe080263d90b361ca48dede96be624.svg";